import type { BuilderConfig } from '@/types/builder';
import Heading from './Heading.vue';
import { headingTypes } from './Heading.types';

export default {
    component: Heading,
    description: 'Heading text component',
    docsLink: 'https://storybook.studydrive.net/?path=/docs/components-heading--docs',
    inputs: [
        {
            name: 'tag',
            description: 'HTML tag to use for the heading',
            helperText: 'Controls SEO',
            type: 'enum',
            required: true,
            enum: [
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
            ],
        },
        {
            name: 'type',
            description: 'Heading type for design',
            helperText: 'Controls Appearance',
            type: 'enum',
            required: true,
            enum: headingTypes.filter((_) => _.startsWith('heading-')),
        },
        {
            name: 'text',
            description: 'Heading Text',
            type: 'string',
            required: true,
            defaultValue: 'Heading',
        },
    ],
    shouldReceiveBuilderProps: {
        builderLinkComponent: false,
    },
} satisfies BuilderConfig;
